module.exports = __webpack_public_path__ + "img/desabilitar.23da75ca.svg";